export const capitalizeFirstLetter = (text: string): string => {
  const labelToLowerCase = text.toLowerCase();
  return labelToLowerCase.charAt(0).toUpperCase() + labelToLowerCase.slice(1);
};
